import {
  FETCH_ALL_RECIPE_INGREDIENCES,
  RESET_RECIPE_INGREDIENCES,
  REMOVE_RECIPE_INGREDIENCE,
  ADD_RECIPE_INGREDIENCE,
  UPDATE_RECIPE_INGREDIENCE,
} from '../../mutation-types';

export default {
  [RESET_RECIPE_INGREDIENCES](state) {
    state.all = [];
  },

  [FETCH_ALL_RECIPE_INGREDIENCES](state, recipeIngrediences) {
    state.all = recipeIngrediences;
  },

  [REMOVE_RECIPE_INGREDIENCE](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_RECIPE_INGREDIENCE](state, recipeIngredience) {
    state.all.push(recipeIngredience);
  },

  [UPDATE_RECIPE_INGREDIENCE](state, { recipeIngredience, id }) {
    state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        Object.keys(recipeIngredience).map((k) => {
          p[k] = recipeIngredience[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeIngredience/mutations.js